import styles from "./MethodStep.module.css";
import type { MethodStepProps } from "./MethodStep.types";

export function MethodStep({ icon, title, description }: MethodStepProps) {
  return (
    <div className={styles.step}>
      <span className={styles.iconWrap} aria-hidden>
        {icon}
      </span>
      <div className={styles.text}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
}
